const docFiles = /\.(doc|docx)$/;
const pdfFiles = /\.(pdf)$/;
const pptFiles = /\.(pptx|pptm|ppt|ppsx|pps)$/;
const xlsFiles = /\.(xlsx|xls|xlsm)$/;
const imageFiles = /\.(gif|jpg|jpeg|bmp|png|svg|webp)$/;

export function isDoc(name: string): boolean {
  return docFiles.test(name);
}

export function isXls(name: string): boolean {
  return xlsFiles.test(name);
}

export function isPpt(name: string): boolean {
  return pptFiles.test(name);
}

export function isPdf(name: string): boolean {
  return pdfFiles.test(name);
}

export function isImage(name: string): boolean {
  return imageFiles.test(name);
}
